/**
 * Created by Ning Jiang on 2024-03-11.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";
import {DeadwoodRipReelView} from "../../reels/DeadwoodRipReelView";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRipGameAssets} from "../../DeadwoodRipGameAssets";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DeadwoodRipStackedWild} from "../../symbol/DeadwoodRipStackedWild";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class TotalMultiplierController extends WinPresentationController {

    constructor() {
        super("TotalMultiplierController", false);

        if(DeadwoodRip.model.isRestore) {
            DeadwoodRip.multiplier.updateMultiplier(DeadwoodRip.model.parsedInitData.currentMultiplier, false)
            DeadwoodRip.model.parsedInitData.multiplierOnReels.forEach((m, reelId) => {
                if(m > 0) {
                    const w = <DeadwoodRipStackedWild>DeadwoodRip.reels[reelId].getSymbol(0);
                    if(!w.updateMultiplier) {
                        throw new Error(`Nudge error on reelId ${reelId}, symId:${0}`);
                    }
                    w.updateMultiplier(m, false)
                }
            });
        }
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.multiplierOnReels.some(m => m > 0);
    }

    protected async createWinAnimation():Promise<void> {
        const promises:Promise<any>[] = [];
        let delay = 0;
        DeadwoodRip.model.parsedGameData.multiplierOnReels.forEach((m, reelId) => {
            if(m === 0) {
                return;
            }
            DeadwoodRip.playScattersWin = true;
            const text = new PIXI.BitmapText(`${DeadwoodRip.model.data.mode === GameMode.NORMAL ? `+` : `x`}${m}`, {
                fontName : DeadwoodRipGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
                fontSize : 46,
                tint : 0xffffff
            });
            (<PIXI.Point>text.anchor).set(0.5, 1.36);
            text.letterSpacing = -32;
            text.position.set(DeadwoodRipReelView.REEL_AREAS[reelId].x, 578);
            text.visible = false;
            DeadwoodRipLayers.getLayer(Layers.WIN_TEXTS)?.addChild(text);
            text.updateTransform();
            if(text.textWidth > 130) {
                text.scale.x = MathHelper.roundToDecimals(130 / text.textWidth, 2);
            }
            const sym = DeadwoodRip.reels[reelId].getSymbol(1) as DeadwoodRipStackedWild;
            const tl = new TimelineLite();
            tl.add([
                () => {
                    text.visible = true;
                    DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.NUDGE_TO_MULTI[reelId - 1]});
                },
                gsap.to(text, {
                    duration : 0.3,
                    x : DeadwoodRip.multiplier.x,
                    y : DeadwoodRip.multiplier.y,
                    ease : "power4.out"
                })
            ], delay);
            tl.add(() => {
                text.parent.removeChild(text);
                text.destroy();
                DeadwoodRip.multiplier.updateMultiplier(this.getEndMultiplier(m), true);
            });
            tl.add(sym.getNudgeEndAnimation(), delay);
            promises.push(Promise.resolve(tl));
            delay += 0.3;
        });
        await Promise.all(promises);
    }

    private getEndMultiplier(reelM:number):number {
        if(DeadwoodRip.model.data.mode === GameMode.NORMAL) {
            return DeadwoodRip.multiplier.currentMultiplier + reelM;
        }

        return DeadwoodRip.multiplier.currentMultiplier * reelM;
    }
}